/**
 * A list of two character country codes that Accenture does not do business in.
 */

export const COUNTRY_CODE_BLOCKLIST = ['RU', 'BY', 'CU', 'IR', 'KP', 'SY', 'UA'];
